import datatables from 'datatables';
import 'datatables.mark.js';

export default () => {
  var table = $('#research_table').DataTable({
    paging: false,
    mark: true,
    "searching": true,
    "autoWidth": false,
    "order": [0, 'desc'],
    "language": {
      "emptyTable": "Ingen data tillgänglig",
    },
  });
  $('#research-search').keyup(function(){
    var text = $(this).val();
    table.search(text).draw();
  });
  if($('.sorting_desc').length > 0 || $('.sorting_asc').length > 0) {
    if($('.sorting_desc').attr('aria-sort') == 'ascending') {
      $('.sorting_desc').append('<i class="far indicator fa-sort-amount-up-alt"></i>');
    } else {
      $('.sorting_desc').append('<i class="far indicator fa-sort-amount-down-alt"></i>');
    }
  }
  $('.sorting, .sorting_desc, .sorting_asc').each(function(){
    $(this).click(function(){
      $('.sorting').each(function(){
        $(this).children('svg').remove();
      });
      var text = $(this).text();
      if($(this).attr('aria-sort') == 'ascending') {
        $(this).children('svg').remove();
        $(this).append('<i class="far indicator fa-sort-amount-up-alt"></i>');
      } else {
        $(this).children('svg').remove();
        $(this).append('<i class="far indicator fa-sort-amount-down-alt"></i>');
      }
    });
  });
};

